"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _commission = require("@/api/marketing/commission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommissionConfig',
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      loading: false,
      formData: {
        id: '',
        popupId: '',
        popupDesc: '',
        withdrawDesc: ''
      },
      advList: [],
      qrcodeList: [],
      rules: {
        popupId: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择客服'
        }],
        popupDesc: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写客服按钮文案'
        }],
        withdrawDesc: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写提现说明'
        }]
      }
    };
  },
  created: function created() {
    this.getQrcodeList();
    this.getConfigInfo();
  },
  methods: {
    // 获取配置信息
    getConfigInfo: function getConfigInfo() {
      var _this = this;
      this.loading = true;
      (0, _commission.commissionConfigApi)().then(function (data) {
        return _this.initFormData(data);
      }).finally(function () {
        _this.loading = false;
      });
    },
    initFormData: function initFormData(data) {
      for (var k in data) {
        this.formData[k] = data[k];
      }
    },
    getQrcodeList: function getQrcodeList() {
      var _this2 = this;
      (0, _lotteryAssistant.getEnableQrcodeListApi)().then(function (data) {
        _this2.qrcodeList = data || [];
      });
    },
    handleSubmit: function handleSubmit(name) {
      var _this3 = this;
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this3.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this3.$message.warning(msg);
          }
        }
      });
    },
    getFormData: function getFormData() {
      return _objectSpread({}, this.formData);
    },
    // 新增保存数据
    postData: function postData() {
      var _this4 = this;
      this.loading = true;
      var data = this.getFormData();
      if (!data) {
        this.loading = false;
        return;
      }
      (0, _commission.commissionUpdateConfigApi)(data).then(function (res) {
        _this4.$message.success('保存成功');
      }).finally(function (err) {
        _this4.loading = false;
      });
    },
    //立即前往
    handlerToLink: function handlerToLink(url) {
      var _this$$router$resolve = this.$router.resolve({
          path: url
        }),
        href = _this$$router$resolve.href;
      window.open(href);
    }
  }
};